<template>
  <div class="cat-year-row cursor-scroll-all">
   <transition name="cat-year-row"> 
    <div class="cat-year-row-inner">
      <map-year-label-column v-for="year in riskData" 
        :key="year.year"
        :yearData="year">
      </map-year-label-column> 
    </div>
   </transition>
  </div>
</template>

<script>
import MapControlsDatesColumn from './MapControlsDatesColumn';

export default {
  name: 'map-control-dates',
  props: ['riskData'],
  components: {
    'map-year-label-column': MapControlsDatesColumn,
  },
};
</script>

<style>
  .cat-year-row {
    height: 20px;
  }
  .first-cat-year-row {
    height: 40px;
  }
  .cat-year-row-inner {
    display: flex
  }
  .cat-year-row-enter-active {
    transition: all .2s linear;
  }

  .cat-year-row-leave-active,  {
    transition: all .2s linear;
  }


  .cat-year-row-enter, .cat-year-row-leave-to {
    opacity: 0;
    overflow: hidden;
  }
</style>



// WEBPACK FOOTER //
// MapControlsDates.vue?709026d4